import React, {useRef} from 'react';
import Rail from '@dazn/lp-web/src/components/Rail/Rail';
import {IArticlesRail} from '@dazn/lp-web/src/types';
import {useSyncElementsHeight} from '../../hooks/useSyncElementsHeight';

interface IArticlesRailProps {
    data: IArticlesRail;
    disableAnimation: boolean;
}

const ArticlesRail: React.FC<IArticlesRailProps> = ({
    data,
    disableAnimation
}) => {
    const articlesRailWrapper = useRef(null);
    useSyncElementsHeight(articlesRailWrapper);

    return (
        <div ref={articlesRailWrapper}>
            <Rail
                key={data.componentType}
                rail={data}
                disableAnimation={disableAnimation}
            />
        </div>
    );
};

export default ArticlesRail;
